import dataRootRoute from './data-root-route'
import dataPlanDetailRoute from './data-plans-detail-route'

export default () => [
  dataRootRoute(),
  dataPlanDetailRoute(),
]
